import { api } from './customers'

export interface Branch {
    id: number,
    activeStatus: number,
    isMainBranch: number
    branchName: string,
    address: string,
    city: string,
    state: string,
    country: string,
    pincode: any,
    emailId: string,
    mobileNo: any,
}

type Branches = Branch[]


export const BranchesApi = api.injectEndpoints({
    endpoints: (build) => ({
        getBranch: build.query<Branches, void>({
            query: () => 'hospital_branch',
            transformResponse: (response: { data: Branches }, meta, arg) => response.data,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Branch' as const, id })),
                        { type: 'Branch', id: 'LIST' },
                    ]
                    : [{ type: 'Branch', id: 'LIST' }],
        }),
        addBranch: build.mutation<Branch, Partial<Branch>>({
            query: (body) => ({
                url: `hospital_branch`,
                method: 'POST',
                body,
            }),
            
            transformResponse: (response: { data: Branch }, meta, arg) => response.data,
            invalidatesTags: [{ type: 'Branch', id: 'LIST' }],
        }),
        getBranchById: build.query<Branch, string>({
            query: (id) => `hospital_branch/${id}`,
            transformResponse: (response: { data: Branch }, meta, arg) => response.data,
        }),

        updateBranch: build.mutation<void, Pick<Branch, 'id'> & Partial<Branch>>({
            query: ({ id, ...patch }) => ({
                url: `hospital_branch/${id}`,
                method: 'PUT',
                body: patch,
            }),
            invalidatesTags: [{ type: 'Branch', id: 'LIST' }],

        }),
        deleteBranch: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `hospital_branch/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: [{ type: 'Branch', id: 'LIST' }],

        }),
    }),
})

export const {
    useGetBranchQuery,
    useAddBranchMutation,
    useGetBranchByIdQuery,
    useUpdateBranchMutation,
    useDeleteBranchMutation,
} = BranchesApi

